import { loadFlowGuideSteps, toBodyHtml, type GuideStep } from "../loadProjectOverviewGuideSteps";
import { materialsMapExistingUserSteps } from "../steps/materialsMapExistingUserSteps";
import { materialsMapNewUserSteps } from "../steps/materialsMapNewUserSteps";
import { MATERIALS_MAP_FLOW_KEY } from "../welcomeFlow.config";
import { replayGuideStep } from "./replayGuideStep";
import type { WelcomeDeckWithFlow } from "./WelcomeDeck";

const FIRST_BUILDING_MATERIAL_ANCHOR_ID = "first-building-material";
// The Library's first card — the deck's own ending, a plain Finish (nowhere to hand the user off to).
const ENDING_ANCHOR_ID = "first-material";

// Not a Carbon0 row — inserted right after the first building element to explain HOW mapping happens, which none of the guide's own rows say.
const HOW_TO_MAP_STEP: GuideStep = {
  id: "",
  key: "materials-map-how-to",
  anchorId: FIRST_BUILDING_MATERIAL_ANCHOR_ID,
  title: "How to map",
  bodyHtml: toBodyHtml(
    "Drag a material or construction from the Library onto an element to map it, using the grip handle on its card. The mapped share in the header grows as you go, and you can click a mapped element any time to review or adjust it."
  ),
  alreadySeen: false,
  highlight: true,
};

// The guide's own rows come from the "Mapping View" Carbon0 view; orderStepsForDeck (WelcomeTour.vue) floats the ending row past them for us, and the replay card past that.
async function loadMaterialsMapDeckSteps(): Promise<GuideStep[]> {
  const steps = await loadFlowGuideSteps("Mapping View");
  const firstBuildingMaterialIndex = steps.findIndex((step) => step.anchorId === FIRST_BUILDING_MATERIAL_ANCHOR_ID);
  if (firstBuildingMaterialIndex === -1) {
    return [...steps, replayGuideStep("sub-sidebar-material-mapping-nav-link")];
  }
  return [
    ...steps.slice(0, firstBuildingMaterialIndex + 1),
    HOW_TO_MAP_STEP,
    ...steps.slice(firstBuildingMaterialIndex + 1),
    replayGuideStep("sub-sidebar-material-mapping-nav-link"),
  ];
}

export const materialsMapDeck: WelcomeDeckWithFlow = {
  id: "materialsMap",
  flowKey: MATERIALS_MAP_FLOW_KEY,
  intro: {
    new: materialsMapNewUserSteps[0],
    existing: materialsMapExistingUserSteps[0],
  },
  loadSteps: loadMaterialsMapDeckSteps,
  ending: {
    anchorId: ENDING_ANCHOR_ID,
    // Always a plain Finish — nowhere for this deck to hand the user off to.
    ctaLabel: () => undefined,
    runCta: () => {},
  },
};
